import { AwxConnectedAccountType } from '@ankor-io/common/types/awx'

export type ModuleThemeColours = {
  // Button colour
  button: 'primary' | 'orange'
  // Badge colour
  badge: 'primary' | 'orange'
  // Link colour
  link: string
  // Text colour
  text: string
  // Emphasis text (e.g. bold amounts)
  textEmphasis: string
  // Background colour
  background: string
  // Border colour
  border: string
  // Spinner 2 colours
  spinner: {
    colour1: string
    colour2: string
  }
  // fill colour
  fill: string
  /** CSS variable reference for dropdown item focus/hover background (e.g. var(--color-primary-500)) */
  dropdownAccentVar: string
}

const APA_COLOURS: ModuleThemeColours = {
  button: 'primary',
  badge: 'primary',
  link: 'text-primary-600 dark:text-primary-400',
  text: 'text-blue-600 dark:text-blue-400',
  textEmphasis: 'text-primary-900 dark:text-primary-300',
  background: 'bg-blue-50 dark:bg-blue-950/20',
  border: 'border-blue-200 dark:border-blue-200/50',
  spinner: {
    colour1: '#184CE8',
    colour2: '#9164EE',
  },
  fill: 'fill-primary-600',
  dropdownAccentVar: 'var(--color-primary-500)',
}

const OPERATIONS_COLOURS: ModuleThemeColours = {
  button: 'orange',
  badge: 'orange',
  link: 'text-orange-600 dark:text-orange-400',
  text: 'text-orange-500 dark:text-orange-400',
  textEmphasis: 'text-orange-900 dark:text-orange-300',
  background: 'bg-orange-50 dark:bg-orange-950/20',
  border: 'border-orange-200 dark:border-orange-200/50',
  spinner: {
    colour1: '#EA580C',
    colour2: '#FB923C',
  },
  fill: 'fill-orange-600',
  dropdownAccentVar: 'var(--color-orange-500)',
}

export const MODULE_THEME_COLOURS: Record<AwxConnectedAccountType, ModuleThemeColours> = {
  [AwxConnectedAccountType.APA]: APA_COLOURS,
  [AwxConnectedAccountType.OPERATIONS]: OPERATIONS_COLOURS,
}

/** Default module when no active account (e.g. auth screens) */
export const DEFAULT_MODULE_TYPE: AwxConnectedAccountType = AwxConnectedAccountType.APA

export function getModuleThemeColours(moduleType: AwxConnectedAccountType): ModuleThemeColours {
  return MODULE_THEME_COLOURS[moduleType] ?? MODULE_THEME_COLOURS[DEFAULT_MODULE_TYPE]
}
